<template>
  <!--<router-link :to="{ name: item.router }" v-if="item.router">-->
  <router-link :to="changeParam(item.router)" v-if="item.router">
    <v-list-tile
      :class="{ 'v-leftmenu-active': changeActive(item.router, activeRouter) || isCurrent(item)}"
      :key="i"
      @click="changeRouter(item)"
    >
      <v-list-tile-action
        v-if="item.icon"
      >
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{item.title}}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </router-link>
</template>

<script>
  export default {
    name: "LeftMenuAction",
    props: ['item', 'activeRouter', 'i', 'currentInstance'],
    data() {
      return {
        localActiveRouter: this.activeRouter || '',
      }
    },
    methods: {
      changeParam: function (router) {
        if (typeof (router) === "object") {
          return {name: router.name, params: router.params};
        } else {
          return {name: router};
        }
      },
      changeRouter: function (router) {
        let emited = {};
        if (typeof (router.router) == "object") {
          emited = {name: router.router.name, params: router.router.params}
        } else {
          emited = {name: router.router}
        }
        if (router.name !== undefined)
          emited['instance'] = router.name;
        this.$emit('changeActiveRouter', emited)
      },
      changeActive: function (router, activeRouter) {
        if (activeRouter === null)
          return false;
        let router1 = "";
        let router2 = "";
        if (typeof (router) === "object") {
          router1 = router.name;
        } else {
          router1 = router;
        }
        if (typeof (activeRouter) === "object") {
          router2 = activeRouter.name;
        } else {
          router2 = activeRouter;
        }

        return router1 === router2;
      },
      isCurrent: function (item) {
        if (this.currentInstance !== undefined && item.name !== undefined)
          return this.currentInstance === item.name;
        return false;
      }
    }
  }
</script>

<style scoped>

</style>
